import { faShareNodes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

interface ShareButtonProps {
    url: string;
    title?: string;
}

const ShareButton: React.FC<ShareButtonProps> = ({ url, title = "Check this out!" }) => {
    const handleShare = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        if (navigator.share) {
            try {
                await navigator.share({
                    title,
                    url,
                });
            } catch (error) {
                return null;
            }
        } else {
            // Fallback: copy to clipboard
            navigator.clipboard.writeText(url);
            alert("Link copied to clipboard!");
        }
    };

    return (
        <>
            <button
                onClick={handleShare}
                title="More share options"
                className="flex gap-2 items-center justify-center px-4 py-3 rounded-lg bg-plot-orange text-white hover:shadow-lg hover:shadow-plot-orange/30 transition-all cursor-pointer shrink-0"
            >
                <FontAwesomeIcon icon={faShareNodes} />
                Share
            </button>
        </>
    );
};

export default ShareButton;
